import { SVGProps } from 'react';

const SearchMethodIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 2.667V1.333M2.667 8H1.333M8 13.333v1.334M13.333 8h1.334"
    />
  </svg>
);

export default SearchMethodIcon;
